// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1DOko","selects":"Documents_selects__QiNzF"};